jQuery( function ( $ ) {

  const $nav = $( '#intl-nav' );
  if ( !$nav.length ) { return; }

  const $trigger = $nav.find( '#intl-trigger' );
  const $menu = $nav.find( '#intl-menu' );
  let close_debounce;

  function set_open ( open ) {
    clearTimeout( close_debounce )
    $trigger.attr( 'aria-expanded', open )
    $menu.attr( 'aria-hidden', !open )
    if ( open ) {
      $menu.addClass( 'visible' )
    } else {
      close_debounce = setTimeout( () => $menu.removeClass( 'visible' ), 300 )
    }
  }

  $nav
    .on( 'mouseenter', () => set_open( true ) )
    .on( 'mouseleave', () => set_open( false ) )
    .on( 'focusout', function ( e ) {
      if ( ! $.contains( this, e.relatedTarget ) ) {
        set_open( false )
      }
    });

  $trigger
    .on( 'click', () => set_open( $trigger.attr( 'aria-expanded' ) == 'false' ) )


});